var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.isMobileVertical
    ? _c(
        "div",
        { staticClass: "header-body" },
        [
          _c("Logo"),
          _c("div", { staticClass: "right-panel" }, [
            _c("div", { staticClass: "bet-range" }, [
              _c("span", { staticClass: "bet-range-label" }, [
                _vm._v(" " + _vm._s(_vm.$t("Max")) + ": "),
              ]),
              _c("span", [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.formatAmountWithKM(_vm.mainLimitAmountPerFight, 0)
                    )
                ),
              ]),
              _c("div", { staticClass: "drop-down disable" }, [
                _c("div", { staticClass: "drop-down-item" }, [
                  _c("img", {
                    attrs: {
                      src: require("@/assets/svg/chart-icons/banker.svg"),
                      alt: "Banker",
                    },
                  }),
                  _c("img", {
                    attrs: {
                      src: require("@/assets/svg/chart-icons/player.svg"),
                      alt: "Player",
                    },
                  }),
                  _c("span", { staticClass: "limit-text" }, [
                    _vm._v(
                      _vm._s(
                        _vm.formatAmountWithKM(_vm.mainLimitAmountPerFight, 0)
                      )
                    ),
                  ]),
                ]),
                _c("div", { staticClass: "drop-down-item" }, [
                  _c("img", {
                    staticClass: "draw-icon",
                    attrs: {
                      src: require("@/assets/svg/chart-icons/draw.svg"),
                      alt: "Draw",
                    },
                  }),
                  _c("span", { staticClass: "limit-text" }, [
                    _vm._v(
                      _vm._s(
                        _vm.formatAmountWithKM(_vm.drawLimitAmountPerFight, 0)
                      )
                    ),
                  ]),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "menu" }, [
              _vm.lobbyUrl
                ? _c(
                    "div",
                    {
                      staticClass: "menu-item menu-lobby",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.redirectToLobby()
                        },
                      },
                    },
                    [
                      _c("img", {
                        staticClass: "logo",
                        attrs: { src: _vm.getImgUrl("lobby") },
                      }),
                      _c("div", { staticClass: "text-label" }, [
                        _vm._v(_vm._s(_vm.$t("Lobby"))),
                      ]),
                    ]
                  )
                : _vm._e(),
              _c(
                "div",
                {
                  class: [
                    "menu-item menu-history",
                    { active: _vm.activePopupPage === _vm.PopupPage.history },
                  ],
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.openMenuPopup("History")
                    },
                  },
                },
                [
                  _c("img", {
                    staticClass: "logo",
                    attrs: { src: _vm.getImgUrl("history") },
                  }),
                  _c("div", { staticClass: "text-label" }, [
                    _vm._v(_vm._s(_vm.$t("History"))),
                  ]),
                ]
              ),
              _c(
                "div",
                {
                  class: [
                    "menu-item menu-help",
                    { active: _vm.activePopupPage === _vm.PopupPage.help },
                  ],
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.openMenuPopup(_vm.PopupPage.help)
                    },
                  },
                },
                [
                  _c("img", {
                    staticClass: "logo",
                    attrs: { src: _vm.getImgUrl("help") },
                  }),
                  _c("div", { staticClass: "text-label" }, [
                    _vm._v(" " + _vm._s(_vm.$t("Help")) + " "),
                  ]),
                ]
              ),
              _c(
                "div",
                { staticClass: "menu-item menu-language" },
                [_c("LanguageDropdown")],
                1
              ),
            ]),
            _c("div", { staticClass: "header-item" }, [
              _c(
                "div",
                {
                  staticClass: "user",
                  class: { "cursor-pointer": _vm.withCommission },
                },
                [
                  _c("img", {
                    attrs: { src: require("@/assets/images/user.webp") },
                  }),
                  _vm._v(_vm._s(_vm.memberName) + " "),
                  _c(
                    "div",
                    { staticClass: "drop-down" },
                    [
                      _vm.config.availableOddsType.length > 1
                        ? _c("ToggleBtn", {
                            staticClass: "drop-down-item",
                            attrs: {
                              leftTxt: _vm.$t("Eu"),
                              rightTxt: _vm.$t("My"),
                              value: _vm.toggleValue,
                            },
                            on: { toggle: (e) => _vm.toggleOdds(e) },
                          })
                        : _vm._e(),
                      _vm.withCommission
                        ? _c(
                            "div",
                            {
                              staticClass: "drop-down-item",
                              on: {
                                click: function ($event) {
                                  return _vm.logoutCreditUser()
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("Logout")))]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              ),
            ]),
            _c(
              "div",
              { staticClass: "header-item relative" },
              [
                _c(
                  "div",
                  {
                    staticClass: "balance",
                    class: { "tooltip-container": _vm.isLargeBalance },
                  },
                  [
                    _vm._v(" " + _vm._s(_vm.currencySymbol) + " "),
                    _c("animated-amount", {
                      attrs: {
                        value: _vm.balance,
                        formatValue: _vm.isLargeBalance
                          ? _vm.formatLargeAmount
                          : _vm.formatAmount,
                        duration: 500,
                      },
                    }),
                    _vm.isLargeBalance
                      ? _c("span", { staticClass: "balance-tooltip" }, [
                          _vm._v(
                            _vm._s(_vm.$t("Balance")) +
                              ": " +
                              _vm._s(_vm.currencySymbol) +
                              _vm._s(_vm.formatAmount(_vm.balance))
                          ),
                        ])
                      : _vm._e(),
                  ],
                  1
                ),
                _c("Transition", { attrs: { name: "fade" } }, [
                  _vm.futureDiff
                    ? _c("div", { staticClass: "furture-diff" }, [
                        _vm._v("+ " + _vm._s(_vm.userFutureDiff)),
                      ])
                    : _vm._e(),
                ]),
              ],
              1
            ),
          ]),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }